import { Action } from "redux";

export const GEOCALCULATION_VISIBILITY_TOGGLED = "GEOCALCULATION_VISIBILITY_TOGGLED";

export interface SetGeoCalculationVisibilityAction extends Action {
    geoCalculationId: number;
    visibility: boolean;
}

export const setGeoCalculationVisibilityAction = (
    geoCalculationId: number,
    visibility: boolean
): SetGeoCalculationVisibilityAction => {
    return {
        type: GEOCALCULATION_VISIBILITY_TOGGLED,
        geoCalculationId: geoCalculationId,
        visibility: visibility,
    };
};
